<template>
    <div ref="loaderLayout">
        <div class="head-item">
            <!--шапка таргета-->
            <div class="head-item-info" v-bind:class="{ 'in-open': detailedTaskInfo }">
                <div class="info-side">
                    <div class="item-title">
                        <button type="button" id="sidebarCollapse" class="btn">
                            <img src="/assets/back.svg" alt />
                        </button>
                        <h3 class>{{ task.task_name }}</h3>
                    </div>
                </div>
                <div class="btn-line">
                    <button type="button" class="btn btn-success" @click="runTask" v-if="currentStatus == 'Paused' ||
                        currentStatus == 'Continue' ||
                        currentStatus == 'Run'
                    ">
                        <i class="vik" :class="[
                            {
                                'vik-pause': currentStatus == 'Running',
                                'vik-continue': currentStatus == 'Paused',
                                'vik-run': currentStatus == 'Run',
                            },
                        ]"></i>
                        {{ currentStatus }}
                    </button>

                    <button v-if="currentStatus == 'Running'" class="btn btn-success" @click="pauseTask">
                        Pause
                    </button>
                    <button v-if="currentStatus == 'Continue'" class="btn btn-success" @click="stopTask">
                        Stop
                    </button>
                </div>
                <div class="control-side btn-line ml-auto">
                    <button type="button" class="btn btn-sm btn-icon refresh" @click="refresh">
                        <i class="vik vik-refresh"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-icon del" @click="deleteSchedTask($route.params.id)">
                        <i class="vik vik-delete"></i>
                    </button>
                </div>
                <div class="info-Collapse" @click="toggleTaskInfo">
                    <button type="button" id="infoCollapse" class="btn btn-primary btn-icon"
                        v-bind:class="{ 'in-open': detailedTaskInfo }">
                        <i class="vik vik-down"></i>
                    </button>
                </div>
            </div>
            <el-collapse-transition>
                <div id="infoPanel" v-if="detailedTaskInfo">
                    Created:
                    <span style="margin-left: 10px">{{ formatedCreatedDate }}</span>
                </div>
            </el-collapse-transition>

            <div class="filtering">
                <div class="filter-control pill-control">
                    <ul class="nav nav-pills unit-group" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link first-append" v-bind:class="{ active: activeTab == 'info' }"
                                @click="setActiveView('info')" type="button">Info</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link last-append" v-bind:class="{ active: activeTab == 'data' }"
                                @click="setActiveView('data')" type="button">Storage</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link last-append" @click="setActiveView('output')"
                                v-bind:class="{ active: activeTab == 'output' }" data-toggle="pill"
                                type="button">Output</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link last-append" @click="setActiveView('schedule')"
                                v-bind:class="{ active: activeTab == 'schedule' }" data-toggle="pill"
                                type="button">Schedule</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link last-append" @click="setActiveView('logs')"
                                v-bind:class="{ active: activeTab == 'logs' }" data-toggle="pill" type="button">Logs</a>
                        </li>
                    </ul>
                </div>

                <transition name="el-zoom-in-center" mode="out-in">
                    <div class="filter-control-hide" v-if="activeTab == 'data'">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <label class="input-group-text" for="scriptselect">Script:</label>
                            </div>
                            <el-select v-model="selectedScript" placeholder="Select" @change="onscriptselect">
                                <el-option v-for="item in avaliablescriptsToFilter" :key="item.value"
                                    :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <button style="margin-left: 15px" type="button" class="btn btn-sm btn-icon refresh"
                                @click="refresh">
                                <i class="vik vik-refresh"></i>
                            </button>
                            <el-popover style="margin-left: 10px" v-if="selectedRecords.length > 0" placement="right"
                                width="400" trigger="click">
                                <el-table :data="compExportColumns"
                                    @selection-change="handleExportColumnsSelectionChange">
                                    <el-table-column type="selection" width="55">
                                    </el-table-column>
                                    <el-table-column property="column" label="column"></el-table-column>
                                </el-table>
                                <el-button class="btn btn-success btn-sm" @click="exportTableData">
                                    Export
                                </el-button>
                                <el-input v-if="exportResult != ''" type="textarea" :rows="2" v-model="exportResult">
                                </el-input>
                                <el-button slot="reference" style="margin-left: 5px;" class="btn btn-success btn-sm">
                                    Export selected
                                </el-button>

                            </el-popover>
                            <el-button v-if="selectedRecords.length > 0" style="margin-left: 5px;" icon="vik vik-delete"
                                class="btn btn-danger btn-sm" :loading="recordsAreDeleting" @click="removeResults">
                                Remove selected
                            </el-button>
                        </div>
                    </div>
                </transition>

                <!--
          <div
            class="filter-control-hide justify-content-end"
            style="display: none"
          >
            <div class="btn-line">
              <button type="button" class="btn btn-sm btn-primary">Filter</button>
              <button type="button" class="btn btn-sm btn-primary">
                Export records
              </button>
            </div>
          </div>
          -->
            </div>
        </div>
        <div class="item-container">
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane active">
                    <div class="in-out-translate-demo-wrapper">
                        <transition name="in-out-translate-fade" mode="out-in">
                            <template>
                                <div v-if="activeTab == 'info'" key="info" style="
                                        display: flex;
                                        flex-wrap: wrap;
                                        align-items: flex-start;
                                      ">
                                    <div class="atom-card-cont" style="width: 650px">
                                        <h2>Atoms</h2>
                                        <div class="atom-card-list">
                                            <div :key="idx" v-for="(atom_info, idx) in scripts"
                                                class="atom-card status-bar" v-bind:class="{
                                                    'status-process': atom_info.status === 'process',
                                                    'status-pause': atom_info.status === 'paused',
                                                    'status-warning': atom_info.status === 'aborted',
                                                    'status-result': atom_info.status === 'done',
                                                    'status-stop': atom_info.status === 'created',
                                                }">

                                                <div class="atom-card-body">
                                                    <h5 style="width:100%" class="atom-card-title">
                                                        {{ atom_info.title }}
                                                    </h5>

                                                    <div class="atom-card-info-cont">
                                                        <!-- 
                                <span
                                  class="atom-card-info"
                                  v-if="atom_info.variables != '[]'"
                                >
                                  Progress:
                                  {{ parseVariables(atom_info.variables) }}
                                </span>
                              -->
                                                        <span class="atom-card-info">
                                                            status: {{ atom_info.status }}
                                                            {{ getSubtaskProgress(atom_info.progress) }}
                                                        </span>
                                                        <div class="info-Collapse" @click="toggleAtomInfo(idx)">
                                                            <button type="button" id="infoCollapse"
                                                                class="btn btn-primary btn-icon"
                                                                v-bind:class="{ 'in-open': detailedAtomInfo.includes(idx) }">
                                                                <i class="vik vik-down"></i>
                                                            </button>
                                                        </div>
                                                        <el-collapse-transition>
                                                            <div id="infoPanel" v-if="detailedAtomInfo.includes(idx)">
                                                                Settings
                                                                {{ atom_info.settings }}
                                                                Vars
                                                                {{ atom_info.variables }}
                                                                //parseVariables(atom_info.variables)
                                                            </div>
                                                        </el-collapse-transition>
                                                    </div>

                                                </div>




                                                <div class="atom-list-line" v-if="scripts.length != idx + 1"></div>
                                            </div>
                                        </div>
                                        <br />

                                    </div>


                                </div>

                                <div v-if="activeTab == 'data'" key="data">
                                    <div class="result-list" v-if="selectedScript != '' && results_labels.length">
                                        <div class="result-card" :class="[{ active: label == selectedDate }]"
                                            v-for="(label, idx) in results_labels" :key="idx"
                                            @click="onDateSelect(label)">
                                            <span class="relult-date">
                                                {{ label.substring(0, 50) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="selectedScript == ''">script is not selected</div>
                                    <div v-if="selectedScript != '' && !results_labels.length">
                                        no data
                                    </div>
                                    <transition name="in-out-translate-fade" mode="out-in">
                                        <div class="table-responsive" v-if="table.records.length">
                                            <el-table :data="table.records" :filters="table.filters"
                                                v-loading="tableLoading" @selection-change="handleSelectionChange">
                                                <el-table-column type="selection" width="55"></el-table-column>
                                                <el-table-column v-for="(title, idx) in computedColumns"
                                                    :prop="title.key" :label="title.label" :key="title.key"
                                                    :sortable="false">
                                                    <template slot-scope="scope">
                                                        <ColumnRender :format="title.format"
                                                            :value="scope.row[title.prop]"
                                                            :result_id="scope.row.result_id" :result_field="title.prop"
                                                            :task_id="$route.params.id" :key="idx" :date="selectedDate"
                                                            :loadDataURL="generateDataURL(selectedDate, selectedScript, scope.row._result_hash)">
                                                        </ColumnRender>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column width="50">
                                                    <template slot-scope="scope">
                                                        <button type="button" class="btn btn-sm btn-icon del" @click="
                                                            removeResult(
                                                                $route.params.id,
                                                                scope.row._result_hash,
                                                                true
                                                            )
                                                            ">
                                                            <i class="vik vik-delete"></i>
                                                        </button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            <el-pagination style="margin-top: 10px" background
                                                :current-page.sync="resultsPageNum" layout="prev, pager, next, sizes"
                                                :total="table.total" :page-sizes="[10, 100, 1000, 10000]"
                                                :page-size="resultsPageSize" @current-change="changePage"
                                                @size-change="changePageSize"></el-pagination>
                                        </div>
                                        <div v-else>
                                            <span v-if="selectedDate">no matches</span>
                                        </div>
                                    </transition>
                                </div>
                                <div v-if="activeTab == 'output'" key="output">
                                    <div class="terminal-cont">
                                        <vue-terminal style="max-height: 300px !important" :showHeader="false"
                                            :showHelpMessage="true" :ref="`term`" class="native-term" />
                                    </div>
                                </div>
                                <div v-if="activeTab == 'schedule'" key="schedule">
                                    <div class="d-flex mt-3">
                                        <h2>Schedule</h2>
                                        <el-checkbox v-model="schedule.enabled" class="ml-3">Enable
                                            schedule</el-checkbox>
                                    </div>

                                    <el-form class="schedule">
                                        <div class="mt-3" v-if="schedule.enabled">
                                            <label class="el-form-item__label mb-2">Start date</label>
                                            <div class="row">
                                                <div class="col-md-7">
                                                    <div class="d-flex align-items-center">
                                                        <el-form-item prop="startAt" class="mb-0">
                                                            <el-date-picker style="height: 40px"
                                                                v-model="schedule.startAt" type="datetime"
                                                                placeholder="Select date and time"
                                                                format="yyyy-MM-dd HH:mm"
                                                                :picker-options="pickerOptions"></el-date-picker>
                                                        </el-form-item>
                                                        <el-checkbox class="ml-3"
                                                            v-model="schedule.repeat.enabled">Repeat</el-checkbox>
                                                    </div>
                                                </div>
                                                <div class="col-md-5">
                                                    <div class="schedule-timer">
                                                        <div v-if="schedule.repeat.enabled" class="
                                                      secondary-group
                                                      d-flex
                                                      align-items-center
                                                    ">
                                                            <div class="d-flex align-items-center">
                                                                Every
                                                                <el-input-number :min="1" :max="60"
                                                                    class="ml-2 mr-2 underline-input"
                                                                    v-model="schedule.repeat.intervalNum" />
                                                            </div>
                                                            <el-select v-model="schedule.repeat.intervalItem"
                                                                placeholder="Interval" class="small-input">
                                                                <el-option v-for="item in ['minute', 'hour', 'day']"
                                                                    :value="item" :key="item" :label="item + `(s)`">{{
                                                                        item }}(s)</el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <el-form-item class="mb-0 mt-4" v-if="modifiedSchedule"><el-button
                                                @click="updateTaskSchedule" class="btn btn-success"><i
                                                    class="vik vik-save"></i>Save</el-button></el-form-item>
                                    </el-form>
                                </div>
                                <div v-if="activeTab == 'logs'" key="logs">
                                    <div class="table-responsive log-table">
                                        <el-table :data="logs.records" style="width: 100%">
                                            <el-table-column label="Time" width="180">
                                                <template slot-scope="scope">
                                                    <i class="el-icon-time"></i>
                                                    <span style="margin-left: 10px" :title="scope.row.date">{{
                                                        scope.row.date.substr(0, 10)
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Level" width="180">
                                                <template slot-scope="scope">
                                                    <el-tag size="medium">{{ scope.row.level }}</el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Message" prop="message">
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination style="margin-top: 10px" background
                                            :current-page.sync="resultsPageNum" layout="prev, pager, next, sizes"
                                            :total="table.total" :page-sizes="[10, 100, 1000, 10000]"
                                            :page-size="resultsPageSize" @current-change="changePage"
                                            @size-change="changePageSize"></el-pagination>
                                    </div>
                                </div>
                            </template>
                        </transition>
                    </div>
                </div>
            </div>

            <div class="filter-cont" v-if="selectedDate && activeTab == 'data'">
                <transition v-if="displayFilter == false" name="in-out-filter" mode="out-in">
                    <button @click="displayFilter = !displayFilter" class="btn-sm btn-primary" type="button">
                        <i class="vik vik-adjust"></i>Filter
                    </button>
                </transition>
                <transition v-else name="in-out-filter" mode="out-in">
                    <div v-if="displayFilter">
                        <div class="filter-block form-inline" :key="index" v-for="(filter, index) in table.filters">
                            <div class="filter-control-item">
                                <div class="switch-box">
                                    <el-switch v-model="filter.not" active-color="#82b0bf" inactive-color="#c3cbcd"
                                        active-text="NOT"></el-switch>
                                </div>
                            </div>
                            <div class="filter-control-item">
                                <el-select v-model="filter.field">
                                    <el-option :value="column.key" :key="column.key" v-for="column in table.columns">{{
                                        column.key
                                    }}</el-option>
                                </el-select>
                                <el-select value="=" v-model="filter.operator">
                                    <el-option value="equal" label="equal"></el-option>
                                    <el-option value="contains" label="contains"></el-option>
                                    <el-option value="greater" label="greater than"></el-option>
                                    <el-option value="less" label="less than"></el-option>
                                </el-select>
                            </div>
                            <div class="filter-control-item">
                                <input type="text" name="value" class="form-control" placeholder="value"
                                    v-model="filter.value" />
                            </div>
                            <div class="filter-control-item" v-if="table.filters.length > 1">
                                <button type="button" class="btn btn-sm btn-icon del" @click="removeFilterIndex(index)">
                                    <i class="vik vik-delete"></i>
                                </button>
                            </div>
                            <div class="filter-control-item" v-if="index == 0">
                                <button type="button" class="btn-sm btn-primary" @click="addFilter">
                                    <i class="vik vik-plus"></i>
                                    Add rule
                                </button>
                            </div>
                            <div class="filter-control-item ml-auto" v-if="index == 0">
                                <el-button type="button" class="btn-sm btn-success" icon="vik vik-run"
                                    @click="applyFilters">Apply</el-button>
                            </div>
                            <div class="filter-control-item" v-if="index == 0">
                                <button @click="displayFilter = !displayFilter" type="button"
                                    class="btn btn-sm btn-icon refresh">
                                    <i class="vik vik-x"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
    <!--
      <a-drawer
        title="Create new list from results"
        :before-close="handleClose"
        :visible.sync="showFilters"
        direction="rtl"
        ref="drawer_filters"
        :append-to-body="true"
        :wrapperClosable="true"
        @opened="filetersOpened"
        :modal="true"
      >
        <div class="demo-drawer__content">
          <div id="builder-import_export"></div>
          <div class="btn-group">
            <button
              @click="applyFilters"
              class="btn btn-primary parse-sql"
              data-target="import_export"
              data-stmt="false"
            >Apply</button>
          </div>
        </div>
      </a-drawer>
      <a-drawer
        title="Filters"
        :before-close="handleClose"
        :visible.sync="dialog"
        direction="rtl"
        ref="drawer"
        :wrapperClosable="true"
        :modal="true"
      >
        <div class="demo-drawer__content">
          <Res2List
            :date="selectedDate"
            :task_id="$route.params.id"
            :drawer="$refs.drawer"
            :key="selectedDate + ':' + $route.params.id"
          ></Res2List>
        </div>
      </a-drawer>
    </div>
    -->
</template>
<script>
import { bus } from "@/bus.js";
import Vue from "vue";
import Res2List from "@/components/internal/Res2List.vue";
import ColumnRender from "@/components/internal/ColumnRender.vue";
import * as utils from "@/utils.js";
import $ from "jquery";
import "jQuery-QueryBuilder";
import moment from "moment";
import VueTerminal from "@/components/internal/Terminal.vue";
import _ from "lodash";
import {
    getSingleTask,
    getTaskLogs,
    getTaskSchedule,
    runTask,
    pauseTask,
    stopTask,
    deleteSchedTask,
    loadTaskTablesLabels,
    updateTaskSchedule
} from "@/api.js";

export default {
    components: {
        Res2List,
        ColumnRender,
        VueTerminal,
    },
    data() {
        return {
            defaultFilter: {
                not: false,
                operator: "",
                value: "",
                field: "", // define search_prop for backend usage.
            },
            resultsPageSize: 10,
            resultsPageNum: 1,
            resultsTotalRows: 0,
            task: {
                task_name: "",
                status: "created",
            },
            detailedTaskInfo: false,
            detailedAtomInfo: [],
            taskInfoTable: [],
            tableLoading: false,
            scripts: [],
            dialog: false,
            showFilters: false,
            lists: [],
            vars: "",
            schedule: {
                enabled: false,
                startAt: "",
                repeat: {
                    enabled: false,
                    intervalItem: "minute",
                    intervalNum: 1,
                    end: {},
                },
            },
            scheduleState: {},
            showResultTable: false,
            displayFilter: false,
            selectedScript: "",
            selectedDate: "",
            selectedRecords: [],
            exportColumns: [],
            exportFormat: "csv",
            exportResult: "",
            pickerOptions: {
                shortcuts: [
                    {
                        text: "5 mins later",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 300 * 1000);
                            picker.$emit("pick", date);
                        },
                    },
                    {
                        text: "10 mins later",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 600 * 1000);
                            picker.$emit("pick", date);
                        },
                    },
                    {
                        text: "1 hour later",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 600 * 1000);
                            picker.$emit("pick", date);
                        },
                    },
                ],
            },
            table: {
                total: 0,
                filters: [],
                records: [],
                columns: [],
            },
            logs: {
                total: 0,
                filters: [],
                records: [],
            },
            kvColumns: [
                {
                    title: "Name",
                    key: "k",
                    dataIndex: "k",
                },
                {
                    title: "Value",
                    key: "v",
                    dataIndex: "v",
                },
            ],
            activeTab: "info",
            results_labels: [],
            fields: [],
            latestTaskID: null,
            recordsAreDeleting: false,
        };
    },
    beforeMount() {
        this.loadTaskInfo();
        // this.loadTaskTablesLabels();
    },
    mounted() {
        console.log("mounted single task")
        this.checkHash();
        this.resultsPageNum = 1;
        this.resultsPageSize = 10;
        this.resultsTotalRows = 0;
        Vue.nextTick().then(() => {
            this.subscribeToOutput();
        });
    },
    beforeDestroy() {
        this.unsubscribeFromOutput();
        this.latestTaskID = null;
    },
    created() {
        this.addFilter();
    },
    watch: {
        $route(to, from) {
            this.activeTab = "info";

            // reset filters
            this.table.filters = [];
            this.addFilter();

            this.loadTaskInfo();
            // this.loadTaskTablesLabels();
            this.checkHash();
            // this.loadFieldsInfo();
            if (this.latestTaskID) {
                this.unsubscribeFromOutput(this.latestTaskID);
                if (this.latestTaskID != this.$route.params.id) {
                    this.selectedScript = "";
                    this.selectedDate = "";
                    this.refresh();
                }
            }
            this.selectedRecords = []
            Vue.nextTick().then(() => {
                this.subscribeToOutput();
            });
        },
    },
    computed: {
        // showAtomDetails(id){
        //   return true//  this.showAtomDetails[id] == true
        // },
        modifiedSchedule() {
            if (this.scheduleState) {
                return true;
                if (this.scheduleState.enabled !== this.schedule.enabled) return true;
                if (this.scheduleState.startAt !== this.schedule.startAt) return true;

                // repeat
                if (this.scheduleState.repeat.enabled != this.schedule.repeat.enabled)
                    return true;

                if (
                    this.scheduleState.repeat.intervalItem !==
                    this.schedule.repeat.intervalItem
                )
                    return true;
                if (
                    this.scheduleState.repeat.intervalNum !==
                    this.schedule.repeat.intervalNum
                )
                    return true;
            }
            /*if (this.scheduleState == null) {
              return true;
            }
            */
            return false;
        },
        avaliablescriptsToFilter() {
            return _.flatMap(this.scripts, function (o) {
                return { label: o.title, value: o.atom_id };
            });
        },
        currentStatus() {
            switch (this.task.status) {
                case "running":
                    return "Running";
                case "paused":
                    return "Continue";
                default:
                    return "Run";
            }
        },

        computedColumns() {
            return this.table.columns.filter((c) => c.key !== "_result_hash");
        },
        compExportColumns() {
            let cols = []
            let fc = this.table.columns.filter((c) => c.key !== "_result_hash");
            for (let c of fc) {
                cols.push({ column: c.label })
            }
            return cols
        },
        /*
        getTotalReqs() {
          let that = this;
          let totalReqs = 1;
          let progress = parseInt(this.task.progress, 10);
          let targetsCount = parseInt(this.task.targets_count, 10);
          let scriptsTotal = 0;
    
          this.scripts.forEach((atom) => {
            let varsInAtom = 1;
            let jvars = atom.variables;
            for (var i in jvars) {
              let e = jvars[i].split(":");
              let list_id = e[1];
              let listTotal = that.getListTotalByID(e[1]);
              if (listTotal > 0) {
                varsInAtom *= listTotal;
              }
            }
            scriptsTotal += varsInAtom;
          });
          totalReqs = targetsCount * scriptsTotal;
          return `${progress}/${totalReqs}`;
        },
        
        percents() {
          if (this.task.payloads > 0) {
            return parseInt((this.task.progress / this.task.payloads) * 100);
          }
          return 0;
        },
        */

        formatedCreatedDate() {
            return moment(this.task.created, "YYYY-MM-DD HH:mm:ss ZZ z").fromNow();
        },
        validFilters() {
            return _.filter(this.table.filters, function (f) {
                return f.value !== "" && f.field !== "";
            });
        },
    },
    methods: {
        generateDataURL(label, atom, hash) {
            console.log('scope', hash);
            let u = `/api/task/${this.$route.params.id}/tables/data/single/?label=${label}&atom=${atom}&hash=${hash}`
            return u
        },
        addQueryParam(k, v) {
            utils.addQueryParamNoReload(this, k, v);
        },
        onscriptselect() {
            console.log("onscriptselect");
            this.addQueryParam("atom", this.selectedScript);
            this.loadTaskTablesLabels();
        },
        onDateSelect(v) {
            this.selectedDate = v;
            this.resultsPageNum = 1;
            this.addQueryParam("date", v);
            this.onQueryChange("");
        },
        handleSelectionChange(val) {
            console.log("changed", val);
            this.selectedRecords = val
        },
        handleExportColumnsSelectionChange(data) {
            this.exportColumns = data
        },

        toggleTaskInfo() {
            this.detailedTaskInfo = !this.detailedTaskInfo;
        },
        toggleAtomInfo(id) {
            if (this.detailedAtomInfo.includes(id)) {
                var index = this.detailedAtomInfo.indexOf(id);
                if (index !== -1) {
                    this.detailedAtomInfo.splice(index, 1);
                }
            } else {
                this.detailedAtomInfo.push(id)
            }

            console.log('toggleAtomInfo', this.detailedAtomInfo)
        },
        changePage(pageNum) {
            this.resultsPageNum = pageNum;
            this.onQueryChange({});
        },
        changePageSize(size) {
            this.resultsPageSize = size;
            this.onQueryChange({});
        },
        fixTime(dt) {
            var datetime = new Date(dt);
            let x = new Date(datetime.toString())
            var d = x.getDate();
            var m = x.getMonth() + 1; //Month from 0 to 11
            var y = x.getFullYear();
            let hours = x.getHours()
            let minutes = x.getMinutes()
            console.log('fix', dt, hours)
            return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d) + ' ' + (hours <= 9 ? '0' + hours : hours) + ':' + (minutes <= 9 ? '0' + minutes : minutes) + ':00';
        },
        updateTaskSchedule() {
            let that = this
            let newDate = this.fixTime(this.schedule.startAt)
            this.schedule.startAt = newDate;
            console.log(`${newDate}`)

            updateTaskSchedule(Object.assign({ task_id: this.$route.params.id }, this.schedule)).then((data) => {
                if (data.error) {
                    that.$notify.error({
                        title: "Error",
                        message: data.error,
                    });
                    return
                } else {
                    that.$notify.success({
                        title: "Success",
                        message: "Updated",
                    });
                }
                console.log("data", data);
            });

            /*
            let that = this;
            // this.$refs[formName].validate((valid) => {
            //   console.log("valid=", valid);
            //   if (valid) {
                utils.sendPost("/api/task//save/", this.schedule).then((resp) => {
                  if (resp.error == null) {
                    bus.$emit("refresh-tasks", true);
                    that.$router.push({
                      name: "TaskView",
                      params: { id: "" + resp.taskid },
                    });
                  } else {
                    alert(resp.error);
                  }
                });
              // } else {
              //   console.log("error submit!!");
              //   return false;
              // }
            // });
            */
        },
        exportTableData() {
            let that = this;
            this.exportToCsv("kek.csv", this.selectedRecords, this.exportColumns)
        },
        exportToCsv(filename, data, columns) {
            let cols = []
            for (let c of columns) {
                cols.push(c.column)
            }
            // let columns = columns
            console.log(cols)

            let processRow = function (row) {
                var finalVal = '';
                for (var j = 0; j < cols.length; j++) {
                    let col_name = cols[j]
                    var innerValue = row[col_name] === null ? '' : row[col_name].toString();
                    var result = innerValue.replace(/"/g, '""');
                    if (result.search(/("|,|\n)/g) >= 0)
                        result = '"' + result + '"';
                    if (j > 0)
                        finalVal += ',';
                    finalVal += result;
                }
                return finalVal + '\n';
            };

            var csvFile = '';
            for (var i = 0; i < data.length; i++) {
                csvFile += processRow(data[i]);
            }
            this.exportResult = csvFile
            return

            var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },

        colorByStatus(status) {
            switch (status) {
                case "done":
                    return "green";
                case "running":
                    return "blue";
            }
        },
        filetersOpened() {
            let that = this;
            let _filters = [];
            let _keys = Object.keys(this.fields);
            for (let i in _keys) {
                let _t = this.fields[_keys[i]];
                let t = "string";
                switch (_t) {
                    case "long":
                        t = "integer";
                        break;
                    case "integer":
                        t = "integer";
                        break;
                    default:
                        t = "string";
                }
                _filters.push({
                    id: _keys[i],
                    label: _keys[i],
                    type: t,
                });
            }

            $("#builder-import_export").queryBuilder({
                plugins: ["not-group"],
                filters: _filters,
            });
        },
        getSubtaskProgress(ti) {
            if (ti > 0) {
                let target_idx = parseInt(ti, 10);
                let targetsCount = parseInt(this.task.assets_count, 10);
                let percent = parseInt((target_idx / targetsCount) * 100)
                return `| asset: ${target_idx}/${targetsCount} [${percent}%]`;
            }
            return '';
        },
        /*
        applyFilters() {
          var result = $("#builder-import_export").queryBuilder(
            "getMongo" /*,"getSQL",
            false
    
          );
          console.log(JSON.stringify("filter:", result));
          if (result != null && result != "") {
            this.table.filters[1].value = JSON.stringify(result);
            // elastic...
            if (result.sql != undefined) {
              if (result.sql.length) {
                this.table.filters[1].value = result.sql;
              }
            }
          } else {
            this.table.filters[1].value = "";
          }
        },
        */
        handleClose(done) {
            done();
        },

        async loadLogs() {
            getTaskLogs(this.$route.params.id).then((data) => {
                this.logs.records = data.Records;
            });
        },
        async loadSchedule() {
            getTaskSchedule(this.$route.params.id).then((data) => {
                let that = this
                if (data && data.Schedule) {
                    console.log("got schedule", data);
                    const schedule = data.Schedule;

                    if (schedule.enabled) {
                        this.schedule.enabled = schedule.enabled;
                        if (schedule.startAt !== "") {
                            let dd = new Date(schedule.startAt)
                            let newDate = new Date()
                            newDate.setDate(dd.getUTCDate())
                            newDate.setHours(dd.getUTCHours())
                            newDate.setMinutes(dd.getUTCMinutes())

                            this.schedule.startAt = newDate
                        }

                        if (schedule.repeat_enabled) {
                            this.schedule.repeat.enabled = schedule.repeat_enabled;
                            // parse repeat
                            const repeat_interval = schedule.repeat_interval.split(" ")[1];
                            const parsedInterval = repeat_interval.match(/(\d+)(\w)/);
                            const intervalNum = parsedInterval[1];
                            let intervalItem = parsedInterval[2];
                            this.schedule.repeat.intervalNum = intervalNum;
                            switch (intervalItem) {
                                case "m":
                                    intervalItem = "minute";
                                    break;
                                case "h":
                                    intervalItem = "hour";
                                    break;
                                case "d":
                                    intervalItem = "day";
                                    break;
                            }
                            this.schedule.repeat.intervalItem = intervalItem;
                            this.scheduleState = { ...this.schedule };
                            console.log("scheduleState=", this.scheduleState);
                        }
                    }
                } else {
                    // reset
                    this.schedule.enabled = false;
                }
            });
        },

        onQueryChange(q) {
            let that = this;
            that.tableLoading = true;
            let sort = "";
            if (q.sort != null && q.sort != undefined) {
                // console.log(typeof q.sort.sort);
                if (q.sort.prop != undefined && q.sort.sort != "undefined") {
                    let _order = q.sort.order == "ascending" ? "ASC" : "DESC";
                    sort = q.sort.prop + ":" + _order;
                }
            }
            utils
                .$post(
                    `/api/task/${this.$route.params.id}/tables/data/?label=${this.selectedDate}&atom_hash=${this.selectedScript}&page=${this.resultsPageNum}&pageSize=${this.resultsPageSize}`,
                    { sort: sort, filters: this.validFilters }
                )
                .then((response) => {
                    const ignoredFields = ["_id"];
                    if (response.error == null) {
                        let data = response;
                        if (data.results) {
                            that.table.total = parseInt(data.total);
                            that.resultsTotalRows = parseInt(data.total);
                            let keys = [];
                            // filter uniq titles
                            for (var i in data.results) {
                                let jone = data.results[i];
                                // let jone = JSON.parse(one);
                                let _keys = Object.keys(jone);
                                for (let k in _keys) {
                                    if (keys.indexOf(_keys[k]) === -1) keys.push(_keys[k]);
                                }
                            }

                            let titles = [];
                            for (var k in keys) {
                                that.table.columns = [];
                                if (!ignoredFields.includes(keys[k]))
                                    titles.push({
                                        title: keys[k].toUpperCase(),
                                        key: keys[k],
                                        prop: keys[k],
                                        label: keys[k],
                                        format: keys[k].includes(":image") ? "image" : "text",
                                    });
                            }
                            that.table.columns = titles;
                        }
                        that.table.records = data.results;
                        that.tableLoading = false;
                    } else {
                        alert("Error. Status Code: " + response.status);
                        that.tableLoading = false;
                        return;
                    }
                })
                .catch(function (err) {
                    console.log("Fetch Error :-S", err);
                });
        },
        checkHash() {
            console.log('checkHash')
            if (this.$route.query.tab) {
                this.activeTab = this.$route.query.tab;
                this.refresh();
            }
            if (this.$route.query.atom) {
                this.selectedScript = this.$route.query.atom;
            }
            var lochash = this.$route.hash.substring(1);
            var params = lochash
                .split("&")
                .map((v) => v.split("="))
                .reduce((pre, [key, value]) => ({ ...pre, [key]: value }), {});

            if (params.tab && ["info", "data", "output"].includes(params.tab)) {
                this.activeTab = params.tab;
            }
            /*
            if (this.$route.hash) {
              var date = this.$route.hash.substring(1);
              this.activeTab = "results";
              this.showResultTable = true;
              if (this.selectedDate == date) {
              } else {
                this.selectedDate = date;
                this.loadFieldsInfo();
                this.onQueryChange({ page: 1, pageSize: 15 });
                // this.$refs.resultsTable.doLayout();
              }
            } else {
              this.showResultTable = false;
            }
            */
        },
        refresh() {
            this.loadTaskInfo();
            this.loadTaskTablesLabels();
            if (this.table.total > 0) {
                this.onQueryChange({});
            }
        },
        runTask() {
            runTask({ id: this.$route.params.id }).then((data) => {
                this.task.status = "running";
                setTimeout(this.loadTaskInfo, 2000);
            });
        },
        pauseTask() {
            // call over API
            pauseTask({ id: parseInt(this.$route.params.id) }).then((data) => {
                console.log("data", data);
                this.task.status = "paused";
                setTimeout(this.loadTaskInfo, 5000);
            });
        },
        stopTask() {
            // call over API
            stopTask({ id: parseInt(this.$route.params.id) }).then((data) => {
                setTimeout(this.loadTaskInfo, 2500);
            });
        },

        parseVariables(rawdata) {
            try {
                let data = JSON.parse(rawdata);
                if (data && data.length) {
                    let jvars = data;
                    let out = [];
                    for (var i in jvars) {
                        let e = jvars[i].split(":");
                        let s = e[0];
                        let name = this.getListNameByID(e[1]);
                        out.push(`${s} => ${name}`);
                    }
                    return out.join(", ");
                }
            } catch (e) {
                return "-";
            }
        },
        getListNameByID(_id) {
            for (var i in this.lists) {
                if (this.lists[i].id == _id) {
                    return this.lists[i].list_name;
                }
            }
            return "-";
        },
        getListTotalByID(_id) {
            for (var i in this.lists) {
                if (this.lists[i].id == _id) {
                    return parseInt(this.lists[i].total, 10);
                }
            }
            return 0;
        },
        // loadListInfo(list_id) {
        //   let that = this;
        //   fetch("/api/lists/" + list_id + "/info/")
        //     .then(function (response) {
        //       if (response.status !== 200) {
        //         console.log(
        //           "Looks like there was a problem. Status Code: " + response.status
        //         );
        //         return;
        //       }

        //       response.json().then(function (data) {
        //         /*
        //         that.list_name = data.info[0].list_name;
        //         that.total = parseInt(data.info[0].total);
        //         that.imported = parseInt(data.info[0].imported);
        //         if (data.info[0].total != data.info[0].imported) {
        //           setTimeout(that.loadListInfo, 1000);
        //         }
        //         */
        //       });
        //     })
        //     .catch(function (err) {
        //       console.log("Fetch Error :-S", err);
        //     });
        // },

        // loadLists() {
        //   let that = this;
        //   fetch("/api/lists/")
        //     .then(function (response) {
        //       if (response.status !== 200) {
        //         console.log(
        //           "Looks like there was a problem. Status Code: " + response.status
        //         );
        //         return;
        //       }

        //       response.json().then(function (data) {
        //         that.lists = data.lists;
        //       });
        //     })
        //     .catch(function (err) {
        //       console.log("Fetch Error :-S", err);
        //     });
        // },
        loadTaskInfo() {
            console.log("load task info...")
            let that = this;
            // let loader = this.$loading.show({
            //   // Optional parameters
            //   container: this.$refs.loaderLayout,
            //   canCancel: false,
            //   color: "#BDCDD0",
            //   loader: "dots",
            // });


            this.loadLogs();
            this.loadSchedule();
            getSingleTask(this.$route.params.id).then((res) => {
                console.log("getSingleTask", res);
                this.task = res.Task;
                this.scripts = res.Task.atoms;
                this.detailedAtomInfo = []

                if (this.task.status == 'running') {
                    setTimeout(this.loadTaskInfo, 2000)
                }
                // loader.hide()
            });

        },

        loadTaskTablesLabels() {
            loadTaskTablesLabels(this.$route.params.id, this.selectedScript).then((data) => {
                console.log("loadTaskTablesLabels", data);
                this.results_labels = data.Records;
            });

        },

        setActiveView(state) {
            this.addQueryParam("tab", state);
            this.activeTab = state;
            // check current task...
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    utils.sendPost("/api/tasks/save", this.form).then((resp) => {
                        if (resp.error == null) {
                            bus.$emit("refresh-tasks", true);
                        } else {
                            alert(resp.error);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        deleteSchedTask(id) {
            deleteSchedTask({ id: id}).then((data) => {
                bus.$emit("refresh-tasks", true);
                this.$router.push({ name: "Sched" });
            });
        },
        removeResult(taskID, hash, updateTable) {
            let that = this;
            utils
                .$post(`/api/task/${taskID}/results/remove/`, {
                    hash: hash,
                })
                .then((resp) => {
                    if (resp.error == null) {
                        if (updateTable) {
                            that.onQueryChange({});
                        }
                    } else {
                        alert(resp.error);
                    }
                });
        },
        removeResults() {
            let that = this;
            this.recordsAreDeleting = true;
            this.tableLoading = true;
            for (let i in this.selectedRecords) {
                this.removeResult(this.$route.params.id, this.selectedRecords[i]._result_hash, (i == this.selectedRecords.length - 1))
            }
            this.recordsAreDeleting = false;
            this.tableLoading = false;
        },

        addFilter() {
            this.table.filters.push(Object.assign({}, this.defaultFilter));
        },
        removeFilterIndex(index) {
            if (index > -1) {
                this.table.filters.splice(index, 1);
            }
        },
        applyFilters() {
            console.log(this.table.filters);
            this.pageNum = 1;
            this.onQueryChange("");
        },
        unsubscribeFromOutput(id) {
            try {
                this.sockets.unsubscribe("exec-out-" + id);
            } catch (e) {
                console.log(e);
            }
        },
        subscribeToOutput() {
            let that = this;
            let latestTaskID = this.$route.params.id;
            this.latestTaskID = this.$route.params.id;

            that.sockets.subscribe(`exec-out-${latestTaskID}`, (data) => {
                if (this.$refs.term && this.$refs.term.pushToList) {
                    that.$refs.term.pushToList({
                        time: data.time,
                        // label: "STDOUT",
                        type: "info",
                        message: data.message,
                    });
                }

                /*
                that.$notify.success({
                  title: "Success",
                  message: "Connected to term",
                });
                */
            });

            /*
            this.sockets.subscribe("exec-out-" + this.$route.params.id, (data) => {
              if (this.$refs.scriptsOutput && this.$refs.scriptsOutput.pushToList)
                this.$refs.scriptsOutput.pushToList({
                  time: data.time,
                  label: "STDOUT",
                  type: "info",
                  message: data.message,
                });
            });
            */
            /*
            todo:
            this.$notify.success({
              title: "Success",
              message: "Connected to term",
            });
            */
        },
    },
};
</script>
<style lang="scss">
.slide-enter-active {
    -moz-transition-duration: 0.3s;

    -webkit-tran .slide-enter-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: ease-in;
        -webkit-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to,
    .slide-leave {
        max-height: 100px;
        overflow: hidden;
    }

    .slide-enter,
    .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }

    #infoPanel {
        display: block !important;
    }

    .rotated {
        transform: rotate(-90deg);
    }

    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

#infoPanel {
    display: block !important;
}

.rotated {
    transform: rotate(-90deg);
}

.demo-block-control {
    border-top: solid 1px #eaeefb;
    height: 25px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    color: #d3dce6;
    cursor: pointer;
    position: relative;

    &.is-fixed {
        position: fixed;
        bottom: 0;
        width: 868px;
    }

    i {
        font-size: 16px;
        line-height: 44px;
        transition: 0.3s;

        &.hovering {
            transform: translateX(-40px);
        }
    }

    >span {
        position: absolute;
        transform: translateX(-30px);
        font-size: 14px;
        line-height: 44px;
        transition: 0.3s;
        display: inline-block;
    }

    &:hover {
        color: #409eff;
        background-color: #f9fafc;
    }

    & .text-slide-enter,
    & .text-slide-leave-active {
        opacity: 0;
        transform: translateX(100px);
    }

    .control-button {
        line-height: 26px;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 14px;
        padding-left: 5px;
        padding-right: 25px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/SingleSchedTask.vue